import { Component, OnInit } from '@angular/core';
@Component({ templateUrl: './content.component.html' })
export class TxKeywordSupportComponent implements OnInit {

  dataList = [];

  ngOnInit(): void {
    // Ooredoo
    let qatar_ooredoo = [];

    qatar_ooredoo.push({'name':'OperateId', 'reference':'crweb', 'remark':'call sendSms method'});
    qatar_ooredoo.push({'name':'ServiceId/RecId', 'reference':'ProductId', 'remark':'Id related to the service'});
    qatar_ooredoo.push({'name':'PriceId', 'reference':'billing price', 'remark':'call charge method'});
    qatar_ooredoo.push({'name':'TxPrefix', 'reference':'CorrelatorId when call SendOtp method', 'remark':'Unique alphanumeric transaction id , start with it'});
    qatar_ooredoo.push({'name':'SecondKeyword', 'reference':'Keyword ID', 'remark':'In their system, user can unsub by second keyword'});
    qatar_ooredoo.push({'name':'MT Content', 'reference':'No neNeeded', 'remark':'False'});
    qatar_ooredoo.push({'name':'Broadcast', 'reference':'No Need', 'remark':'False'});
    qatar_ooredoo.push({'name':'RenewalEnabled', 'reference':'True', 'remark':'by our system'});
    qatar_ooredoo.push({'name':'Shortcode Msg', 'reference':'provided by us', 'remark':'subInvalidMsg, unsubInvalidMsg, subHelpMsg, unsubHelpMsg, unsubAllMsg'});
    qatar_ooredoo.push({'name':'Keyword Msg', 'reference':'provided by us', 'remark':'subscribeSuccessMsg, subscribeAlreadyMsg, subscribeFailedMsg, subscribeChargeSuccessMsg, subscribeLowBalanceMsg, renewalSuccessMsg, renewalLowBalanceMsg, unsubscribeSuccessMsg, unsubscribeAlreadyMsg'});

    this.dataList.push({'source':'Qatar Ooredoo', 'fieldList': qatar_ooredoo});

    // Etisalat
    let ua_etisalat = [];
    ua_etisalat.push({'name':'OperatorId', "reference":'OperatorID', 'remark':'SendSms method'});
    ua_etisalat.push({'name':'ServiceId/RecId', "reference":'ServiceTag', 'remark':''});
    ua_etisalat.push({'name':'MCC', "reference":'by telco provider', 'remark':''});
    ua_etisalat.push({'name':'MNC', "reference":'by telco provider', 'remark':''});
    ua_etisalat.push({'name':'MT Content', "reference":'No Need', 'remark':'False'});
    ua_etisalat.push({'name':'Broadcast', "reference":'No Need', 'remark':'False'});
    ua_etisalat.push({'name':'RenewalEnabled', "reference":'No Need', 'remark':'by telco'});
    ua_etisalat.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'subscribeSuccessMsg, subscribeAlreadyMsg,'});
    this.dataList.push({'source':'UAE Etisalat', 'fieldList': ua_etisalat});

    // Etisalat
    let ua_du = [];
    ua_du.push({'name':'OperatorId', "reference":'OperatorID', 'remark':'SendSms method'});
    ua_du.push({'name':'ServiceId/RecId', "reference":'ServiceTag', 'remark':''});
    ua_du.push({'name':'MCC', "reference":'by telco provider', 'remark':''});
    ua_du.push({'name':'MNC', "reference":'by telco provider', 'remark':''});
    ua_du.push({'name':'MT Content', "reference":'No Need', 'remark':'False'});
    ua_du.push({'name':'Broadcast', "reference":'No Need', 'remark':'False'});
    ua_du.push({'name':'RenewalEnabled', "reference":'No Need', 'remark':'by telco'});
    ua_du.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'subscribeSuccessMsg, subscribeAlreadyMsg,'});
    this.dataList.push({'source':'UAE DU', 'fieldList': ua_du});


     // ABIS
     let th_abis = [];
     th_abis.push({'name':'OperatorId', "reference":'telco', 'remark':'th_ais/th_dtac/th_trueh'});
     th_abis.push({'name':'ServiceId/RecId', "reference":'service keyword', 'remark':'need confirm with partner'});
     th_abis.push({'name':'PriceId', "reference":'price', 'remark':'need confirm with partner'});
     th_abis.push({'name':'MT Content', "reference":'True', 'remark':'charge with content'});
     th_abis.push({'name':'Broadcast', "reference":'No Need', 'remark':'False'});
     th_abis.push({'name':'RenewalEnabled', "reference":'True', 'remark':'renewal by our side'});
     th_abis.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'mtContent, mtContentUrl,'});
     this.dataList.push({'source':'Thailand ABIS', 'fieldList': th_abis});

     // IONNEX
     let ionnex = [];
     ionnex.push({'name':'ServiceId/RecId', "reference":'recid', 'remark':'need confirm with partner'});
     ionnex.push({'name':'PriceId', "reference":'', 'remark':'need confirm with partner, normally same price'});
     ionnex.push({'name':'MT Content', "reference":'True', 'remark':'charge with content'});
     ionnex.push({'name':'Broadcast', "reference":'True', 'remark':'renewal by broadcast method, ignore operator, to all telco'});
     ionnex.push({'name':'RenewalEnabled', "reference":'True', 'remark':'renewal by our side'});
     ionnex.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'mtContent, mtContentUrl,'});
     ionnex.push({'name':'*** IMPORTANT', "reference":'', 'remark':'Only need to input one keyword record for all operator'});
     this.dataList.push({'source':'Ionnex(so far only for Thailand keyword)', 'fieldList': ionnex});

     // IONNEX
     let ionnex_mt = [];
     ionnex_mt.push({'name':'OperatorId', "reference":'telcoid', 'remark':'1 -> Maxis, 2 -> Digi, 3 -> Celcom, 4 -> UMobile, 5-> Tune Talk, confirm with partner'});
     ionnex_mt.push({'name':'ServiceId/RecId', "reference":'recid', 'remark':'need confirm with partner'});
     ionnex_mt.push({'name':'PriceId', "reference":'', 'remark':'need confirm with partner, normally realPrice by multipy 100'});
     ionnex_mt.push({'name':'MT Content', "reference":'True', 'remark':'charge with content'});
     ionnex_mt.push({'name':'Broadcast', "reference":'False', 'remark':'Malaysia dont support broadcast method'});
     ionnex_mt.push({'name':'RenewalEnabled', "reference":'True', 'remark':'renewal by our side'});
     ionnex_mt.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'mtContent, mtContentUrl,'});
     ionnex_mt.push({'name':'*** IMPORTANT', "reference":'', 'remark':'So far success integration with Digi, U mobile, Maxis'});
     this.dataList.push({'source':'Ionnex(so far only for Malaysia keyword)', 'fieldList': ionnex_mt});

     // IONNEX
     let qr_solutions = [];
     qr_solutions.push({'name':'OperatorId', "reference":'telcoid', 'remark':'1 -> Maxis, 2 -> Digi, 3 -> Celcom, 4 -> UMobile, 5-> Tune Talk, confirm with partner'});
     qr_solutions.push({'name':'ServiceId/RecId', "reference":'recid', 'remark':'need confirm with partner'});
     qr_solutions.push({'name':'PriceId', "reference":'', 'remark':'need confirm with partner, normally realPrice by multipy 100'});
     qr_solutions.push({'name':'MT Content', "reference":'True', 'remark':'charge with content'});
     qr_solutions.push({'name':'Broadcast', "reference":'False', 'remark':'Malaysia dont support broadcast method'});
     qr_solutions.push({'name':'RenewalEnabled', "reference":'True', 'remark':'renewal by our side'});
     qr_solutions.push({'name':'Keyword Msg', "reference":'provided by us', 'remark':'mtContent, mtContentUrl,'});
     qr_solutions.push({'name':'*** IMPORTANT', "reference":'', 'remark':'So far success integration with Digi, U mobile, Maxis'});
     this.dataList.push({'source':'QR Solution (Malaysia)', 'fieldList': qr_solutions});
  }

}
